<template>
<div>
  <article class="message is-warning is-small">
    <div class="message-body">
      <b>Importante:</b> <br>
       En algunos casos puede que tengas que desactivar tu antivirus para correr el instalador o para jugar. <br>
        Recomendamos agregar la carpeta del juego a las excepciones (White list) de tu antivirus, window defender y/o antispyware.
    </div>
  </article>

  <div class="columns is-centered">

    <div class="column">
      <!-- CLIENT CLASSIC -->
      <div class="card curso">
        <div class="card-header">
          <h2 class="card-header-title is-uppercase has-text-link-dark">
            opción a | mucrisis classic
          </h2>
        </div>
        <div class="card-content">
          <div class="content has-text-justified">
            <p>¡Si eres amante del MU clásico, entonces este Cliente es para tí!</p>

              <ol> <b>Características</b>
                <li>Items de la versión 97d sin modificaciones.</li>
                <li>Mapas de la versión 97d sin alteraciones.</li>
                <li>Camara estática vista aérea como en la vieja escuela.</li>
                <li>Sin brillo, mapas sombríos como debe ser.</li>
                <li>Un Cliente totalmente fiel a la versión Clásica.</li>
                <li>Funciona en casi todas las computadoras con window XP o superior.</li>
              </ol>

          </div>
          <article class="message is-small">
            <div class="message-body has-text-left">
              <b>Versión:</b> 0.02.
            </div>
          </article>
        </div>
        <div class="card-footer">
          <a @click="goTo(links.megaB)" class="card-footer-item has-text-danger has-background-danger-light">Descargar | MEGA</a>
          <a @click="goTo(links.driveB)" class="card-footer-item has-text-success has-background-success-light">Descargar | Google Drive</a>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3 class="card-header-title">
            PARCHES
          </h3>
        </div>
        <div class="card-content">
          <div class="content has-text-justified">
            <p>¡Manten tu cliente actualizado con lo último de MUCRISIS!</p>
            <ul>
              <li v-for="(p,n) in patch" :key="n">
                <a :href="p.link" target="_blank" rel="nofollow">
                  {{p.description}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="column">
      <!-- CLIENTE NEW -->
      <div class="card">
        <div class="card-header">
          <h2 class="card-header-title is-uppercase has-text-warning-dark">
            opción b | mucrisis original
          </h2>
        </div>
        <div class="card-content">
          <div class="content has-text-justified">
            <p>Te invitamos a probar el juego con nuestro Cliente principal, el cual trae una gran cantidad de diseños Originales de MUCRISIS y ciertas características que te facilitaran la jugabilidad.</p>

  <article class="message is-info is-small">
    <div class="message-body">
      <b>Información:</b> <br> Todavía nos encontramos trabajando en este Cliente por lo que está muy poco optimizado y es probable que no llegue a funcionar en todas las computadoras. Si surge algún invonveniente al iniciar el juego, se recomienda instalar los suplementos (mostrados en la lista de abajo) y ejecutar el juego como Administrador.
    </div>
  </article>


              <ol> <b>Características</b>
                <li>Nuevo diseño de mapas.</li>
                <li>Brillo aumentado en ítems y poderes.</li>
                <li>Mejora de texturas.</li>
                <li>Interfaz amigable.</li>
                <li>Diseño propio de inicio y selección de personajes.</li>
                <li>Camara 3D con Zoom.</li>
                <li>Minimapa</li>
                <li>Launcher con Actualizaciones automáticas.</li>
              </ol>


          </div>
        </div>
        <div class="card-footer">
          <a @click="goTo(links.megaA)" class="card-footer-item has-text-danger has-background-danger-light">
            <span>Descargar | MEGA</span>
          </a>
          <a @click="goTo(links.driveA)" class="card-footer-item has-text-success has-background-success-light">
            <span>Descargar | Google Drive</span>
          </a>
        </div>
      </div>
      <!-- LIBRERIAS -->
      <div class="card">
        <div class="card-header">
          <h2 class="card-header-title is-uppercase">
            Suplementos
          </h2>
        </div>
        <div class="card-content">
          <div class="content has-text-justified">
            <p>Dependiendo de la versión de tu sistema operativo puede que necesites instalar alguna de las siguientes librerías para jugar.</p>
            <ul>
              <li>
                <a @click="goTo(links.visualC)">Microsoft Visual C++</a>
              </li>
              <li>
                <a @click="goTo(links.framework)">Microsoft .NET Framework</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
    name: 'PlayGameView',
    beforeCreate(){
      this.$store.dispatch('setPage', {
        location:{name:'play',number:3},
        title:'Juega MUCRISIS gratis',
        breadcrumb:[
          {name:'inicio',link:this.$store.state.baseUrl,active:true, icon:'home'},
          {name:'jugar',link:'/jugar',active:false, icon:'dragon'}
        ]
      })
    },
    data:()=>({
      links: {
        megaA:'#',
        driveA:'#',
        visualC:'#',
        framework:'#',
        megaB:'#',
        driveB:'#',
      },
      patch: [
        { description:'Parche 0.02', link:'#' }
      ]
    }),
    methods: {
      copyServerLink() {
        this.$toasted.show("¡El enlace se ha copiado en el portapapeles!", { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 2500,
          icon : {
            name : 'info-circle'
          }
        })
      },
      goTo(url) {
        window.open(url);
      }
    }
}
</script>

<style>
.curso {
    position:relative;
}

.curso::before {
    position:absolute;
    top:14px;
    right:-42px;
    display: block;
    box-sizing:border-box;
    content:"¡Recomendado!";
    text-transform:uppercase;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 11px;
    text-align:center;
    font-weight: 700;
    color: #fff;


        background: transparent; 
        height:0;
        width:160px;                      

        border:25px solid transparent;
        border-bottom:25px solid rgb(50, 115, 220, .8);
        line-height:23px;
    
    transform: rotate(45deg);
  }

</style>